// extracted by mini-css-extract-plugin
export var statItem = "_jq-1";
export var statsRow = "_jq-0";